// Mock data for Ortodontia Líder website

export const clinicInfo = {
  name: "Ortodontia Líder",
  rating: 5.0,
  address: "Av. Pref. Dr. Roque Vernalha, 1703 – Jardim Araca, Paranaguá – PR, CEP 83221-000",
  phone: "(41) 98477-8785",
  whatsapp: "5541984778785",
  hours: {
    weekdays: "Segunda a sexta: 09:00 às 19:00",
    weekend: "Sábado e domingo: fechado"
  },
  experience: "15 anos",
  // Ficha oficial no Google Maps (link limpo, sem parâmetros de rastreamento)
  googleMapsUrl:
    "https://www.google.com/maps/place/Ortodontia+L%C3%ADder/@-25.5221521,-48.5348451,16.54z/data=!4m12!1m5!3m4!2zMjXCsDMxJzM3LjIiUyA0OMKwMzEnNTkuNCJX!8m2!3d-25.527!4d-48.53317!3m5!1s0x94db9aef69612753:0x62f3c14e6e8416ec!8m2!3d-25.5222251!4d-48.5323444!16s%2Fg%2F1tfznh0w?hl=pt-BR",
  googleMapsEmbed:
    "https://www.google.com/maps?q=-25.5222251,-48.5323444&z=17&hl=pt-BR&output=embed",
  /** Mesmo ponto da ficha no Google Maps — abre rota no app Waze */
  wazeUrl: "https://waze.com/ul?ll=-25.5222251,-48.5323444&navigate=yes",
};

export const treatments = [
  {
    id: 1,
    category: "Ortodontia",
    items: [
      { title: "Aparelho fixo tradicional", description: "O clássico que funciona bem — dentes alinhados com segurança." },
      { title: "Aparelho estético (porcelana ou safira)", description: "Menos visível no dia a dia — quase ninguém percebe." },
      { title: "Alinhadores transparentes", description: "Tipo uma placa fina — tira para comer e ninguém vê." },
      { title: "Manutenção do aparelho", description: "Consultas de acompanhamento para o resultado ficar certinho." },
      { title: "Avaliação ortodôntica", description: "A gente olha seu caso e explica as opções sem compromisso." }
    ]
  },
  {
    id: 2,
    category: "Odontologia Estética",
    items: [
      { title: "Clareamento dental", description: "Dentes mais brancos de forma natural — sorriso renovado." },
      { title: "Facetas em resina", description: "Corrige formato e cor rapidamente, sem demorar meses." },
      { title: "Lentes de contato dental", description: "Transforma o sorriso com resultado bonito e duradouro." },
      { title: "Restaurações estéticas", description: "Conserta o dente e fica com aparência natural." }
    ]
  },
  {
    id: 3,
    category: "Clínica Geral",
    items: [
      { title: "Consulta e avaliação", description: "Primeira consulta para entender o que sua boca precisa." },
      { title: "Limpeza dental", description: "Tira o tártaro e previne cárie e problema na gengiva." },
      { title: "Restaurações (obturações)", description: "Trata a cárie e deixa o dente firme de novo." },
      { title: "Tratamento de gengiva", description: "Gengiva sangrando ou inchada? A gente cuida disso." }
    ]
  },
  {
    id: 4,
    category: "Endodontia",
    items: [
      { title: "Tratamento de canal", description: "Acaba com a dor e salva o dente — sem precisar arrancar." },
      { title: "Retratamento de canal", description: "Canal antigo deu problema? A gente resolve." }
    ]
  },
  {
    id: 5,
    category: "Odontologia Preventiva",
    items: [
      { title: "Orientação de higiene bucal", description: "Aprenda a escovar e usar fio dental do jeito certo." },
      { title: "Aplicação de flúor", description: "Fortalece o dente e ajuda a evitar cárie." },
      { title: "Selantes dentários", description: "Proteção extra contra cárie, principalmente nas crianças." }
    ]
  },
  {
    id: 10,
    category: "Implantes dentários",
    items: [
      { title: "Implante de um dente", description: "Dente novo que parece de verdade — volta a comer normal." },
      { title: "Próteses sobre implantes", description: "Vários dentes de uma vez, firmes e confortáveis." },
      { title: "All-on-4 e All-on-6", description: "Arco completo com menos cirurgias — sorriso novo em menos tempo." },
      { title: "Enxerto de osso", description: "Quando precisa preparar o osso antes do implante." }
    ]
  },
  {
    id: 6,
    category: "Odontopediatria",
    items: [
      { title: "Dentista para criança", description: "Atendimento calmo e sem medo — a criança se sente à vontade." },
      { title: "Prevenção infantil", description: "Cuidado desde cedo para o sorriso crescer saudável." },
      { title: "Aparelho para criança", description: "Correção no tempo certo evita tratamento mais caro depois." }
    ]
  },
  {
    id: 7,
    category: "Cirurgia Oral",
    items: [
      { title: "Extração de dente", description: "Tira o dente com segurança quando não tem mais jeito de salvar." },
      { title: "Extração do siso", description: "Siso incomodando? Procedimento planejado e bem cuidado." },
      { title: "Pequenas cirurgias", description: "Procedimentos simples com orientação clara antes e depois." }
    ]
  },
  {
    id: 8,
    category: "Tratamentos Funcionais",
    items: [
      { title: "Placa para bruxismo", description: "Protege os dentes de quem range à noite." },
      { title: "Dor na mandíbula (ATM)", description: "Alívio para quem sente dor ao abrir a boca ou mastigar." }
    ]
  },
  {
    id: 9,
    category: "Prótese Dentária",
    items: [
      { title: "Próteses fixas", description: "Dentes novos colados — firmes e com boa aparência." },
      { title: "Próteses removíveis", description: "Opção mais acessível para repor vários dentes." },
      { title: "Coroas dentárias", description: "Cobre o dente danificado e devolve a função." }
    ]
  }
];

export const heroImages = {
  hero: "/images/IMG_5902.jpg",
  dentalChair: "/images/cadeira.jpg",
  consultation: "/images/dr-leandro.jpg",
  treatmentRoom: "/images/area-trabalho.jpg",
  procedure: "/images/instrumentos.jpg"
};
